import React from 'react';
import pure from 'purecss/build/buttons-core-min.css';
import classnames from 'classnames';
import { FaPaypal } from 'react-icons/fa';
import style from './style.scss';

const {
    colbyGiving: { paypalId },
} = window;

export default function PayPal() {
    return (
        <form
            action="https://www.paypal.com/cgi-bin/webscr"
            method="post"
            className={style.form}
        >
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input
                type="hidden"
                name="hosted_button_id"
                value={`${paypalId}`}
            />
            <input
                type="hidden"
                name="return"
                value={`${window.location.href}?payment-thankyou=true`}
            />
            <button
                className={classnames({
                    [pure['pure-button']]: true,
                    [style.buttonGive]: true,
                    [style.paypal]: true,
                })}
                onClick={() => {}}
                type="submit"
                name="submit"
                aria-label="PayPal"
            >
                <FaPaypal size="3em" />
            </button>
        </form>
    );
}
